import React from "react";
import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { DialogDescription, DialogTitle } from "@/styles/ui/dialog";
import { SubmitButton } from "@/components/login/submit-button";
import { popModal } from "@/stores/modal";

export const VerificationErrorModal: React.FC = () => {
  return (
    <ModalWrapper className="flex flex-col gap-4 bg-white rounded-[10px] p-6 w-[425px]">
      <div className="flex flex-col gap-1.5">
        <DialogTitle className="headline-1-semibold text-[#0A0A0A]">
          인증 중 오류가 발생했습니다.
        </DialogTitle>
        <DialogDescription className="label-1-normal-regular text-[#0A0A0A]">
          번거로우시겠지만, 로그인 정보를 다시 입력해 주세요.
        </DialogDescription>
      </div>
      <SubmitButton
        text="로그인 화면으로 이동"
        onClick={() => {
          popModal();
          window.location.href = "/login";
        }}
      />
    </ModalWrapper>
  );
};
